import React from "react";

import { Col, Container, Image, Row } from "react-bootstrap";

import DocumentComponent from "../components/Document.component";
import HeroComponent from "../components/Hero.component";
import ScheduleComponent from "../components/Schedule.component";
import OurStoryScreen from "../components/screens/OurStory.component";
import teamData from "../data/team.json";
import i18n from "../i18n";

interface ITeam {
  name: string;
  title: string;
  description: string;
  img: {
    src: string;
  };
}

const About = (): React.JSX.Element => {
  const { t } = i18n;

  return (
    <React.Fragment>
      <DocumentComponent title={t("Who We Are")} />

      <HeroComponent
        style={{ backgroundColor: "var(--bg-light-color)" }}
        title={t("Who We Are")}
      />

      <OurStoryScreen />

      <Container fluid className="teamContainer">
        <Container>
          <Row className="mb-5">
            <Col md={{ span: 10, offset: 1 }} xs={12}>
              <h2>{t("Our Team")}</h2>
            </Col>
          </Row>
        </Container>
      </Container>

      {teamData.map((item: ITeam, index: number) => {
        let imgContainerOrder = "order-1 order-lg-2";
        let contentContainerOrder = "order-2 order-lg-1";
        let textAlignClass = "text-center text-lg-start";
        let alignItemClass = "align-items-center align-items-lg-start";
        let contentOffset = 1;

        if (index % 2 === 0) {
          imgContainerOrder = "order-1 order-lg-1";
          contentContainerOrder = "order-2 order-lg-2";
          textAlignClass = "text-center text-lg-start";
          alignItemClass = "align-items-center align-items-lg-start";
          contentOffset = 0;
        }

        return (
          <Container key={item.name}>
            <Row className="mt-4 mb-4">
              <Col
                className={`${contentContainerOrder} ${textAlignClass}`}
                lg={{ span: 6, offset: contentOffset }}
                xs={12}
              >
                <div className={`flexContainer ${alignItemClass}`}>
                  <h3 className="modelHeader">{t(item.name)}</h3>
                  <h4>{t(item.title)}</h4>
                  <p style={{ fontSize: "1rem", fontWeight: "normal" }}>
                    {t(item.description)}
                  </p>
                </div>
              </Col>

              <Col className={imgContainerOrder} lg={5} xs={12}>
                <div className="flexContainer" style={{ alignItems: "center" }}>
                  <Image
                    rounded
                    alt={t(item.name)}
                    className="mt-4 mb-4"
                    src={item.img.src}
                    style={{ maxWidth: "70%" }}
                    title={t(item.name)}
                  />
                </div>
              </Col>
            </Row>

            {index + 1 !== teamData.length && (
              <Row key={item.title} className="mt-4 mb-4">
                <Col className="d-block d-lg-none order-0" xs={12}>
                  <hr />
                </Col>
              </Row>
            )}
          </Container>
        );
      })}

      <ScheduleComponent />
    </React.Fragment>
  );
};

export default About;
